import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { switchMap } from "rxjs";
import {
  IActa,
  IAnyos,
  IDocente,
  INotificaciones,
  IPeriodos,
  ISeccionDocente,
  ISedes,
} from "src/app/interfaces/portal-calificaciones";
import { PerfilamientoService } from "src/app/services/perfilamiento/perfilamiento.service";
import { PortalCalificacionesService } from "src/app/services/portal-calificaciones/portal-calificaciones";
import { cloneDeep } from "lodash";

@Component({
  selector: "app-portal-calificaciones",
  templateUrl: "./portal-calificaciones.component.html",
  styleUrls: ["./portal-calificaciones.component.scss"],
})
export class PortalCalificacionesComponent implements OnInit {
  filtroAnyo: number = 0;
  filtroPeriodo: number = 0;
  filtroSede: number = 0;
  listaAnyo: Array<number> = [];
  listaPeriodo: any = [];
  listaSede: any = [];
  lista: Array<ISeccionDocente> = [];
  listaNotificaciones: Array<INotificaciones> = [];
  listaNotificacionesCurr: Array<INotificaciones> = [];
  nombreDocente: string = "-";
  idDocente: string = "-";
  tableRender: boolean = false;
  error: string = "";
  expandirNotificaciones: boolean = true;
  expandirFiltros: boolean = false;

  infoModalTitulo: string = "";
  infoModalTexto: string = "";
  cargaDeFiltros: boolean = false;
  filtrosCargados: any = {};

  alertaExitosa: string = "";
  guardadoExitoso: string = "";
  submitted: boolean = false;
  tieneErrores: any = {};
  cargarDatosDocente = true;

  datosDocente: any = {
    anyo: null,
    periodoId: null,
  };

  vistaBackoffice: boolean = false;
  filtrosAdm: any | null = null; // NOSONAR

  constructor(
    private readonly  _portalServices: PortalCalificacionesService,
    private readonly _perfilamiento: PerfilamientoService,
    private readonly router: Router
  ) {
    const routerData =
      this.router.getCurrentNavigation()?.extras?.state?.["data"];
    this.filtrosAdm = cloneDeep(routerData?.filtros);
    if (
      this._perfilamiento.getUsuario().tipoUsuario === "Backoffice" &&
      routerData?.filtros === undefined
    ) {
      this.router.navigateByUrl("/portal-calificaciones");
    }
    if (
      this._perfilamiento.getUsuario().tipoUsuario === "Backoffice" &&
      routerData?.filtros
    ) {
      this.vistaBackoffice = true;
    }

    if (routerData?.ponderacionEditada) {
      this.alertaExitosa =
        "La configuración del registro se ha guardado exitosamente.";
      setTimeout(() => {
        this.alertaExitosa = "";
      }, 15000);
    }
    if (routerData?.filtros) {
      this.cargarDatosDocente = false;
      this.filtroAnyo = routerData?.filtros.anyo;
      this.filtrosCargados = routerData.filtros;
      this.cargaDeFiltros = true;
      this.expandirFiltros = true;
      this.cargarFiltros("anyo");
      this.busqueda(); // 1505 tiempo respuesta
    }
    if (routerData?.guardadoCalificacion) {
      this.guardadoExitoso = "El registro se ha guardado exitosamente";
      setTimeout(() => {
        this.guardadoExitoso = "";
      }, 15000);
    }
  }

  validarVolver() {
    this.router.navigate(["/portal-calificaciones"], {
      state: {
        data: {
          filtros: this.filtrosAdm,
        },
      },
    });
  }

  cargarFiltros(filtro: string): void {
    switch (filtro) {
      case "anyo":
        this.obtenerPeriodos(this.filtroAnyo);
        break;
      case "periodo":
        this.obtenerSedes(this.filtroAnyo, this.filtroPeriodo);
        break;
      default:
        this.busqueda();
        break;
    }
  }
  ngOnInit(): void {
    this._portalServices
      .obtenerListaAnhos()
      .pipe(
        switchMap((res: IAnyos) => {
          this.listaAnyo = res.anyos;
          const filtroDocenteIdBackoffice = this?.filtrosCargados?.docenteId
            ? this.filtrosCargados.docenteId
            : 0;
          return this._portalServices.obtenerDocente(filtroDocenteIdBackoffice);
        })
      )
      .subscribe({
        next: (res: IDocente) => {
          if (res.error != null) {
            this.error = res.error.details[0];
            this.limpiarError();
          } else {
            this.nombreDocente = res.docente;
            this.idDocente = res.docenteId.toString();

            if (this.cargarDatosDocente) {
              if (res.anyoAcademico != null && res.periodoAcademicoId != null) {
                this.datosDocente.anyo = res.anyoAcademico;
                this.datosDocente.periodoId = res.periodoAcademicoId;
                if (this.listaAnyo.includes(res.anyoAcademico)) {
                  this.filtroAnyo = res.anyoAcademico;
                } else {
                  this.filtroAnyo = this.listaAnyo[0];
                }
                this.filtrosCargados = {
                  periodoId: res.periodoAcademicoId,
                  sedeId: 0,
                };
                this.cargaDeFiltros = true;
                this.expandirFiltros = true;
                this.cargarFiltros("anyo");
              }
            }
          }
        },
        error: (error) => {
          this.limpiarError();
        },
      });

    this._portalServices.obtenerNotificaciones().subscribe({
      next: (res: INotificaciones[]) => {
        this.listaNotificaciones = res;
        this.filtrarListaNotificaciones();
      },
    });
  }

  obtenerPeriodos(anyo: number): void {
    this.filtrosCargados.anyo = this.filtroAnyo;
    this.limpiarFiltros("anyo");
    if (anyo != 0) {
      this.tieneErrores["anyo"] = false;
      this._portalServices.obtenerListaPeriodos(anyo).subscribe({
        next: (res: IPeriodos) => {
          this.listaPeriodo = res.periodos;
          if (this.cargaDeFiltros) {
            this.filtroPeriodo = this.filtrosCargados.periodoId;
            delete this.filtrosCargados.periodoId;
            this.cargarFiltros("periodo");
          }
        },
      });
    }
  }
  obtenerSedes(anyo: number, periodoId: number): void {
    this.limpiarFiltros("periodo");
    this.tieneErrores["periodo"] = false;
    const filtroDocenteIdBackoffice = this?.filtrosCargados?.docenteId
      ? this.filtrosCargados.docenteId
      : 0;
    if (anyo != 0 && periodoId != 0) {
      this._portalServices
        .obtenerListaSedes(anyo, periodoId, filtroDocenteIdBackoffice)
        .subscribe({
          next: (res: ISedes[]) => {
            this.listaSede = res;
            if (this.cargaDeFiltros) {
              if (this.filtrosCargados.sedeId) {
                this.filtroSede = this.filtrosCargados.sedeId;
                delete this.filtrosCargados.sedeId;
              } else {
                // this.filtroSede = this.listaSede[0].sedeId
                this.filtroSede = 0;
                this.cargarFiltros("");
              }
            }
          },
          error: (error) => {},
        });
    }
  }

  limpiarFiltros(filtro: string): void {
    switch (filtro) {
      case "anyo":
        this.filtroPeriodo = 0;
        this.filtroSede = 0;
        this.listaPeriodo = [];
        this.listaSede = [];
        break;
      case "periodo":
        this.filtroSede = 0;
        this.listaSede = [];
        break;
      default:
        this.resetearValidaciones();
        if (
          this.datosDocente.anyo != null &&
          this.datosDocente.periodoId != null
        ) {
          this.filtroAnyo = this.datosDocente.anyo;
          this.filtrosCargados = {
            periodoId: this.datosDocente.periodoId,
            sedeId: 0,
          };
          this.cargaDeFiltros = true;
          this.expandirFiltros = true;
          this.cargarFiltros("anyo");
        } else {
          this.filtroAnyo = 0;
          this.filtroPeriodo = 0;
          this.filtroSede = 0;
          this.listaPeriodo = [];
          this.tableRender = true;
          this.lista = [];
          this.tableRender = false;
        }
        break;
    }
  }
  resetearValidaciones(): void {
    this.submitted = false;
    this.tieneErrores["anyo"] = false;
    this.tieneErrores["periodo"] = false;
  }

  filtrarListaNotificaciones() {
    this.listaNotificacionesCurr = this.listaNotificaciones.filter(
      (lista: INotificaciones) => {
        return (
          lista.anyoAcademico == this.filtroAnyo &&
          lista.periodoAcademicoId == this.filtroPeriodo
        );
      }
    );
  }

  getFiltros(filtro: string): any {
    let varFiltroAnyo =
      this.filtrosCargados?.anyo != null
        ? Number(this.filtrosCargados?.anyo)
        : this.filtroAnyo;
    let varFiltroPeriodo =
      this.filtrosCargados?.periodoId != null
        ? Number(this.filtrosCargados?.periodoId)
        : this.filtroPeriodo;
    let varFiltroSede =
      this.filtrosCargados?.sedeId != null && this.filtrosCargados?.sedeId != 0
        ? Number(this.filtrosCargados?.sedeId)
        : this.filtroSede;

    switch (filtro) {
      case "filtroAnyo":
        return varFiltroAnyo;
      case "filtroPeriodo":
        return varFiltroPeriodo;
      case "filtroSede":
        return varFiltroSede;
      default:
        return null;
    }
  }

  busqueda(): void {
    this.submitted = true;

    let varFiltroAnyo = this.getFiltros("filtroAnyo");
    let varFiltroPeriodo = this.getFiltros("filtroPeriodo");
    let varFiltroSede = this.getFiltros("filtroSede");

    if (varFiltroAnyo != 0 && varFiltroPeriodo != 0) {
      this.tableRender = false;
      this.filtrarListaNotificaciones();
      const filtroDocenteIdBackoffice = this?.filtrosCargados?.docenteId
        ? this.filtrosCargados.docenteId
        : 0;
      this._portalServices
        .obtenerLista(
          varFiltroAnyo,
          varFiltroPeriodo,
          varFiltroSede,
          filtroDocenteIdBackoffice
        )
        .subscribe({
          next: (res: ISeccionDocente[]) => {
            this.lista = res;
            this.lista.forEach((elemento) => {
              switch (elemento.estado) {
                case "A":
                  elemento.estado = "ABIERTA";
                  break;
                case "C":
                  elemento.estado = "CERRADA";
                  break;
                case "P":
                  elemento.estado = "EN PROCESO";
                  break;
                default:
                  break;
              }
            });
            this.tableRender = true;
            if (this.cargaDeFiltros) {
              this.cargaDeFiltros = false;
            }
            // this.filtrosCargados = {}
          },
          error: (error) => {
            this.limpiarError();
          },
        });
    } else if (this.filtroAnyo == 0) {
      this.tieneErrores["anyo"] = true;
      this.tieneErrores["periodo"] = true;
    } else if (this.filtroPeriodo == 0) {
      this.tieneErrores["periodo"] = true;
    }
  }
  limpiarError(): void {
    setTimeout(() => {
      this.error = "";
    }, 3000);
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo;
    this.infoModalTexto = texto;
    document.getElementById("btn-modal-info")?.click();
  }

  navToSeccion(data: ISeccionDocente, solicitud: string) {
    if (data.estado === "EN PROCESO") {
      return;
    }
    const filtroDocenteIdBackoffice = this?.filtrosCargados?.docenteId
      ? this.filtrosCargados.docenteId
      : 0;
    const filtros: any = {
      anyo: this.filtroAnyo,
      periodoId: this.filtroPeriodo,
      sedeId: this.filtroSede,
      docenteId: filtroDocenteIdBackoffice,
      ...(this?.filtrosCargados?.seccionId && {
        seccionId: this.filtrosCargados.seccionId,
      }),
      ...(this?.filtrosCargados?.dataDocente && {
        dataDocente: this.filtrosCargados.dataDocente,
      }),
    };
    const datosSeccion = {
      anyo: data.anyoAcademico,
      periodoId: data.periodoAcademicoId,
      sedeId: data.sedeId,
      docenteId: this.idDocente,
      seccionId: data.idSeccion,
      asignaturaId: data.asignaturaId,
      ponderacionId: data.ponderacionId,
      nombreSeccion: data.seccion,
      nombreAsignatura: data.asignatura,
      instanciaBBId: data.instanciaBbId,


    };
    if (solicitud == "calificar") {
      const configuracion = {
        anyo: data.anyoAcademico,
        periodoId: data.periodoAcademicoId,
        seccionId: data.idSeccion,
        asignaturaId: data.asignaturaId,
        sedeId: data.sedeId,
        ponderacionId: data.ponderacionId,
        ...(this.filtrosCargados?.docenteId && {
          docenteId: this.filtrosCargados.docenteId,
        }),
      };
      this.router.navigate(["/visualizacion-seccion"], {
        state: {
          data: {
            configuracion,
            editable: data.calificar === 1 ? true : false,
            filtros,
            estado: data.estado,
            alineacion: {
              estadoAlineacion: data.descEstadoAlineacion,
              idAlineacion: data.alineacionId,
              datosSeccion: datosSeccion,
            }
          },
        },
      });
    } else {
      const configuracion = {
        anyo: data.anyoAcademico,
        periodoId: data.periodoAcademicoId,
        sedeId: data.sedeId,
        ponderacionBaseId: data.ponderacionId,
        idSeccion: data.idSeccion,
        idAsignatura: data.asignaturaId,
        esEditable: this.validarBtn(
          "ponderar",
          data.calificar,
          data.ponderar,
          data.estado
        ),
        ...(this?.filtrosCargados?.docenteId && { seccionId: data.idSeccion }),
        ...(this?.filtrosCargados?.docenteId && {
          asignaturaId: data.asignaturaId,
        }),
        ...(this?.filtrosCargados?.docenteId && {
          ponderacionId: data.ponderacionId,
        }),
        ...(this?.filtrosCargados?.docenteId && {
          docenteId: this.filtrosCargados.docenteId,
        }),
      };
      this.router.navigate(["/registro-calificacion"], {
        state: {
          data: {
            configuracion: configuracion,
            filtros: filtros,
          },
        },
      });
    }
  }
  validarBtn(
    columna: string,
    calendarizacion: number,
    modificable: number,
    estado: string
  ): boolean {
    if (calendarizacion === 0) {
      return false;
    } else {
      if (estado == "ABIERTA" && modificable == 1 && columna == "ponderar") {
        return false;
      }
      if (estado == "ABIERTA" && modificable == 0 && columna == "ponderar") {
        return true;
      }
      if (estado == "ABIERTA" && columna == "calificar") {
        return true;
      }
    }
    return false;
  }

  descargarActa(
    seccionId: number,
    anyo: number,
    periodo: number,
    estado: string
  ): void {
    if (estado === "CERRADA") {
      this._portalServices.descargarActa(seccionId, anyo, periodo).subscribe({
        next: (res: IActa) => {
          if (res.error != null) {
            this.error = res.error.mensaje;
            this.limpiarError();
          } else {
            this.saveAsPdfFile(res.archivo, res.nombreArchivo);
          }
        },
        error: (error) => {
          this.limpiarError();
        },
      });
    }
  }
  saveAsPdfFile(base64: string | null, nombreArchivo: string | null) {
    const mediaType = "data:application/pdf;base64,";
    const file = base64;
    let a = document.createElement("a");
    a.href = mediaType + file;
    a.download = nombreArchivo + ".pdf";
    a.click();
  }
  showPopupBlackboard(seccionId: number) {
    const triangle = document.getElementById("triangle-" + seccionId);
    const popOver = document.getElementById("cstm-popover-" + seccionId);
    if (triangle && popOver) {
      triangle.style.display = "block";
      popOver.style.display = "block";
    }
  }
  hidePopupBlackboard(seccionId: number) {
    const triangle = document.getElementById("triangle-" + seccionId);
    const popOver = document.getElementById("cstm-popover-" + seccionId);
    if (triangle && popOver) {
      triangle.style.display = "";
      popOver.style.display = "";
    }
  }
  navToAlineacion(seccion: ISeccionDocente) {
    const datosSeccion = {
      anyo: seccion.anyoAcademico,
      periodoId: seccion.periodoAcademicoId,
      sedeId: seccion.sedeId,
      docenteId: this.idDocente,
      seccionId: seccion.idSeccion,
      asignaturaId: seccion.asignaturaId,
      ponderacionId: seccion.ponderacionId,
      nombreSeccion: seccion.seccion,
      nombreAsignatura: seccion.asignatura,
      instanciaBBId: seccion.instanciaBbId,


    };
    const filtroDocenteIdBackoffice = this?.filtrosCargados?.docenteId
      ? this.filtrosCargados.docenteId
      : 0;
    const filtros: any = {
      anyo: this.filtroAnyo,
      periodoId: this.filtroPeriodo,
      sedeId: this.filtroSede,
      docenteId: filtroDocenteIdBackoffice,
      ...(this?.filtrosCargados?.seccionId && {
        seccionId: this.filtrosCargados.seccionId,
      }),
      ...(this?.filtrosCargados?.dataDocente && {
        dataDocente: this.filtrosCargados.dataDocente,
      }),
    };
      this.router.navigate(["/alineacion-blackboard"], {
        state: {
          data: {
            estado: seccion.descEstadoAlineacion,
            idAlineacion: seccion.alineacionId,
            datosSeccion: datosSeccion,
            editable: seccion.calificar === 1 ? true : false,
            filtros
          },
        },
      });

    /* } */
  }
}
